module.exports = __webpack_public_path__ + "static/wave-2876e638a55395c03b8ff8b2b1907528.png";